/**
 * @author Eric Otto
 */

module.exports = {

    wrapper: null,

    init: function ($container) {
        'use strict';

        this.wrapper = $container
            ? $container.querySelectorAll('.msnry-wrapper')
            : document.querySelectorAll('.msnry-wrapper');

        if (!this.wrapper) {
            return;
        }

        const imagesLoaded = require('imagesloaded'),
            Masonry = require('masonry-layout'),
            that = this;

        for (let i = 0; i < this.wrapper.length; i++) {

            const msnry = new Masonry(this.wrapper[i], {
                itemSelector: '.item',
                columnWidth: '.item-sizer',
                percentPosition: true
            });

            const imgLoad = imagesLoaded(this.wrapper[i]);

            imgLoad.on('done', function () {
                msnry.layout();
                that.wrapper[i].classList.add('loaded');
            });

        }
    }
};
